module.exports = __webpack_public_path__ + "static/media/chef.240bc4bb.svg";